import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        mode: 0
    },
    mutations: {
        setMode(state, mode) {
            state.mode = mode;
        }
    },
    getters: {
        mode: state => {
            return state.mode
        }
    }
})
